module.exports = __webpack_public_path__ + "media/images/bnr-express-sm-9a9b9b8cd9eeefe083f33e77a91515f0.png";